import Cookies, { CookieAttributes } from 'js-cookie'

import { SessionCookie, SessionCookieSchema } from '../../../modules/trials/interfaces'

export interface AuthenticationServiceLike {
	getJwt(): string | undefined
	getSessionCookie(): SessionCookie
	isLoggedIn(): boolean
	logOut(): void
	setCookie(cookieValue: string): void
	setSessionCookie(sessionCookie: SessionCookie): void
}

export class AuthenticationService implements AuthenticationServiceLike {
	static readonly cookieName = 'X-Auth-Jwt'
	static readonly sessionCookieName = 'trial-form-session'
	static readonly emptyStringifiedSessionCookie = '{"storeUuid":"","email":""}'
	static readonly cookieOpts: CookieAttributes = {
		expires: 24 * 60 * 60 * 1000,
		sameSite: 'lax',
		secure: true
	}

	getJwt(): string | undefined {
		return Cookies.get(AuthenticationService.cookieName)
	}

	isLoggedIn(): boolean {
		const jwt = this.getJwt()

		return Boolean(jwt && jwt !== '')
	}

	logOut(): void {
		this.forceExpireCookie()
	}

	setCookie(cookieValue: string): void {
		Cookies.set(AuthenticationService.cookieName, cookieValue, AuthenticationService.cookieOpts)
	}

	setSessionCookie(sessionCookie: SessionCookie): void {
		Cookies.set(
			AuthenticationService.sessionCookieName,
			JSON.stringify(sessionCookie),
			AuthenticationService.cookieOpts
		)
	}

	getSessionCookie(): SessionCookie {
		const sessionCookie = Cookies.get(AuthenticationService.sessionCookieName)

		if (sessionCookie) {
			return SessionCookieSchema.parse(JSON.parse(sessionCookie))
		}

		return SessionCookieSchema.parse({ email: '', storeUuid: '' })
	}

	forceExpireCookie(): void {
		Cookies.set(AuthenticationService.cookieName, '', AuthenticationService.cookieOpts)
	}
}
